export default {
      id: "icon--wear-warm-clothes-usage",
      viewBox: "0 0 32 31.9",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--wear-warm-clothes-usage",
      toString: function () {
        return this.url;
      }
    }